import Vue from "vue";
import Treeselect from '@riophae/vue-treeselect';

Vue.component('tree-select', Treeselect);

Vue.component("wto-tree-select", {
	props: ["options", "placeholder", "filteredOptions", "treeId"],
	data() {
		return {
			selectedOptions: [],
			minimumSearchLength: 3,
		};
	},
	computed: {
		computedValue: {
			get() {
				const text = this.filteredOptions;
				if (!text) return [];
				return this.filteredOptions;
			},
			set(value) {
				this.$emit("update-selected-options", value);
			}
		}
	},	
	methods: {
		clear: function () {
			this.selectedOptions = [];
		},
		injectSearchWrapper: function (treeApp) {
			var initialHandleLocalSearch = treeApp.$refs.treeselect.handleLocalSearch;
			treeApp.$refs.treeselect.handleLocalSearch = function () {
				var searchQuery = this.trigger.searchQuery;
				this.rootOptionsStates.loadingError = "";

				if (searchQuery.length && searchQuery.length < this.$attrs["min-search-length"]) {
					this.rootOptionsStates.loadingError = (
						htmlEntity.decode(window.messages.treeSelectMinlengthError.replace("##error##", this.$attrs["min-search-length"]))
					);
				} else {
					initialHandleLocalSearch.call(this);
				}
			};
		},
		normalizer(node) {
			return {
				children: node.children && node.children.length ? node.children : 0
			}
		},
		onDataChange: function(value){
			this.$emit('on-data-change', value)
		}
	},
	mounted: function () {
		this.injectSearchWrapper(this);
		if(!this.treeId){
			this.treeId = 'tree-select-container';
		}
	},
	template: `
		<div :id="treeId">
	        <tree-select ref="treeselect"
						 @input="onDataChange"
						 :multiple="true"
	                     :options="options"
						 :min-search-length="minimumSearchLength"
	                     :placeholder="placeholder"
						 :normalizer="normalizer"
						 :openOnFocus="true"
	                     v-model="computedValue"
						 :disableFuzzyMatching="true" />
	    </div>
	`
});
